// removed by extract-text-webpack-plugin
module.exports = {"LetsTalkFooter":"LetsTalkFooter__Mnfit","overlay":"overlay__2y8FW","gdpConnect":"gdpConnect__1NGvk","rectangle":"rectangle__3Z93n","gdpText":"gdpText__3F71i","text":"text__3LD9U","desc":"desc__3ZMt3"};


//////////////////
// WEBPACK FOOTER
// ./components/LetsTalk/style.scss
// module id = o9WK
// module chunks = 5